<template>
  <div class="public-content platform-message">
    <div class="breadcrumb">VIP平台信息</div>
    <div class="right-main">
      <!--      查询VIP平台-->
      <el-form :inline="true" :model="formInline" label-width="80px" class="demo-form-inline">
        <el-row>
          <el-col :span="5">
            <el-form-item label="平台号:">
              <!-- <el-input v-model="formInline.code" placeholder="请输入平台号"></el-input> -->
              <el-select clearable v-model="formInline.code" :filter-method="filterMethod" filterable placeholder="请输入平台号">
                <el-option v-for="item in storeListByCode" :key="item.id" :label="item.code" :value="item.code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="平台名称:">
              <el-input v-model="formInline.name" placeholder="请输入平台姓名" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="业务:">
              <el-input v-model="formInline.salename" placeholder="请输入业务姓名" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="手机号:">
              <el-input v-model="formInline.phone" placeholder="请输入手机号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="审核状态:">
              <el-select v-model="formInline.auditStatus" placeholder="请选择" clearable>
                <el-option label="" value="">全部</el-option>
                <el-option label="待审核" value="PENDING"></el-option>
                <el-option label="审核拒绝" value="REFUSE"></el-option>
                <el-option label="已审核" value="HANDLE"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="平台类型:">
              <el-select v-model="formInline.storeTypeid" placeholder="请选择" clearable>
                <el-option label="" value="">全部</el-option>
                <el-option :label="item.name" :value="item.id" v-for="item in platformType" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="平台分类">
              <el-select v-model="formInline.channelCustomer" placeholder="请选择" clearable>
                <el-option label="VIP平台" :value="0"></el-option>
                <el-option label="渠道平台" :value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="申请日期:" class="el-date-width">
              <el-date-picker clearable v-model="date" type="daterange" align="left" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
                format="yyyy - MM - dd " value-format="yyyy-MM-dd" @change="changeDate">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="fn-right form-btn">
            <el-button class="search-ok" @click="queryInfo.pageNum = 1, searchVipPlateform(queryInfo)" round>查询</el-button>
            <el-button class="search-ok" v-if="$hasPermission('crm:admin:vipStore:export')" v-permission="'crm:admin:vipStore:export'" @click="exportExcel" round>导出Excel</el-button>
          </el-col>
        </el-row>
      </el-form>
      <div class="data-list">
        <el-table :data="tableData" border style="width: 100%" @size-change="sizeChange">
          <el-table-column prop="code" label="平台号" min-width="10px"></el-table-column>
          <el-table-column prop="name" label="平台名称" min-width="10px"></el-table-column>
          <el-table-column prop="platformType" label="平台类型" min-width="10">
            <template v-slot="scope">
              <span>{{ scope.row.storeType }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="channelCustomer" label="平台分类" min-width="10">
            <template v-slot="scope">
              <span>{{ scope.row.channelCustomer === 0 ? 'VIP平台' : '渠道平台' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="phone" label="手机号" min-width="10"></el-table-column>
          <el-table-column prop="salesmanName" label="业务" min-width="10"></el-table-column>
          <el-table-column prop="createdTime" label="申请日期" min-width="12"></el-table-column>
          <el-table-column prop="auditStatus" label="审核状态" min-width="10">
            <template v-slot="scope">
              <span v-html="scope.row.auditStatus === 'PENDING' ? '待审核' : scope.row.auditStatus === 'HANDLE' ? '已审核' : '审核拒绝'"></span>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="10px">
            <template v-slot="scope">
              <span class="color-blue" @click="chack(scope.row)" v-if="$hasPermission('crm:admin:vipStore:detail')">查看<br></span>
              <span class="color-blue" v-if="scope.row.auditStatus === 'PENDING' && $hasPermission('crm:admin:vipStore:audit')" @click="toExamine(scope.row)" ref="operationRef">审核<br></span>
              <span class="color-blue" v-if="$hasPermission('crm:admin:vipStore:update')" @click="edit(scope.row)" ref="operationRef">编辑</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--    分页-->
      <v-pagination class="v-pagination" :queryInfo="queryInfo" @changePage="changePage"></v-pagination>
    </div>
  </div>
</template>
<script>
import VPagination from '@/components/Pagination/index.vue'
import { storeGetVipStoreList, storeTypeGetStoreTypeList, vipStoreExport, storeQueryListByCode } from '@/api/crm'
export default {
  name: 'platform-message',
  components: {
    VPagination
  },
  data () {
    return {
      formInline: {
        code: '',
        name: '',
        salename: '',
        phone: '',
        auditStatus: '',
        createTimeBegin: '',
        createTimeEnd: '',
        storeId: '',
        storeTypeid: ''
      },
      tableData: [],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6
        },
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      platformType: [],
      gridData: [{
        date: '2016-05-02',
        name: '王小虎',
        address: '上海'
      }],
      queryInfo: {
        type: 3,
        pageNum: 1, // 当前显示第几页
        pageSize: 10, // 每一页显示条数
        total: 0
      },
      date: '',
      storeListByCode: []
    }
  },
  created () {
    if (sessionStorage.getItem('searchFlag') === 'true') {
      this.formInline = JSON.parse(sessionStorage.getItem('queryParams'))
      this.queryInfo = JSON.parse(sessionStorage.getItem('queryInfo'))
      this.date = [this.formInline.createTimeBegin, this.formInline.createTimeEnd]
      sessionStorage.removeItem('searchFlag')
    } else {
      // 首次进入列表页,清除缓存中的搜索条件
      sessionStorage.removeItem('queryParams')
      sessionStorage.removeItem('queryInfo')
    }
    if (this.$route.query.auditStatus === 'PENDING') {
      this.formInline.auditStatus = 'PENDING'
    }
    this.getPlatformType()
    this.searchVipPlateform(this.queryInfo)
  },
  destroyed () {
    // 销毁
    console.log('页面销毁')
    sessionStorage.removeItem('searchFlag')
  },
  methods: {
    // 查看
    chack (row) {
      sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
      this.$router.push({ path: '/vipViewStore', query: { id: row.id } })
    },
    // 审核
    toExamine (row) {
      sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
      this.$router.push({ path: '/vipCheckplatform', query: { id: row.id, code: row.code } })
    },
    // 编辑
    edit (row) {
      sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
      this.$router.push({ path: '/vipEditplatform', query: { id: row.id, auditStatus: row.auditStatus } })
    },
    filterMethod (val) {
      if (val.trim()) {
        storeQueryListByCode(val).then(res => {
          if (res.data.success) {
            this.storeListByCode = res.data.data
          }
        })
      }
    },
    // 设置cookie
    setCookie () {
      // 获取当前路由，将当前页面的路由作为name存入cookie中
      let name = this.$route.path
      // 需要存入的参数
      document.cookie = name + '=' + this.$qs.stringify(this.formInline)
    },
    // 从cookie中获取之前存入的参数
    // data为指定页面的路由，当从指定页面返回到当前页面时才到cookie中获取上一次存入的参数 。
    getCookie (data) {
      if (data === '/checkplatform' || data === '/editplatform') {
        let name = this.$route.path
        let reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
        let arr = document.cookie.match(reg)
        // if (arr === document.cookie.match(reg)) {
        this.formInline = this.$qs.parse(arr[2])
        if (this.formInline.phone) {
          this.formInline.phone = this.$msg.filterBridal(this.formInline.phone)
        }
        if (this.formInline.platformTypeid !== '') {
          this.formInline.platformTypeid = parseInt(this.formInline.platformTypeid)
        }
        // }
      }
    },
    getPlatformType () {
      storeTypeGetStoreTypeList().then((res) => {
        this.platformType = res.data.data
      })
    },
    searchVipPlateform (val) {
      // 设置参数
      if (sessionStorage.getItem('searchFlag')) {
        sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
        sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
      }
      storeGetVipStoreList({ pageNum: val.pageNum, pageSize: val.pageSize, storeVo: this.formInline }).then((res) => {
        if (res.data.success) {
          this.queryInfo.total = res.data.data.total
          this.tableData = res.data.data.records.map(a => {
            if (a.phone) {
              a.phone = this.$msg.filterBridal(a.phone)
            }
            return a
          })
        }
      })
    },
    changePage (val) {
      this.queryInfo = val
      this.searchVipPlateform(this.queryInfo)
    },
    deleteEmptyProperty (object) {
      for (var i in object) {
        var value = object[i]
        if (typeof value === 'object') {
          if (Array.isArray(value)) {
            if (value.length === 0) {
              delete object[i]
              continue
            }
          }
          this.deleteEmptyProperty(value)
          if (this.isEmpty(value)) {
            delete object[i]
          }
        } else {
          if (value === '' || value === null || value === undefined) {
            delete object[i]
          } else {
          }
        }
      }
      return object
    },
    getPlatformStatus (scope, e) {
      let status = e.target.innerText
      if (status === '审核') {
        this.$router.push({
          path: '/checkplatform',
          query: {
            id: scope.id,
            code: scope.code
          }
        })
      }
      if (status === '查看/编辑') {
        this.$router.push({
          path: '/editplatform',
          query: {
            id: scope.id
          }
        })
      }
    },
    exportExcel () {
      const loading = this.$loading({
        lock: true,
        text: '正在导出表格，请稍后',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let _this = this
      vipStoreExport(_this.formInline).then(res => {
        let blob = res.data
        const fileReader = new FileReader()
        fileReader.readAsDataURL(blob)
        fileReader.onload = (event) => {
          let a = document.createElement('a')
          let _fileName = ''
          if (this.formInline.createTimeBegin && this.formInline.createTimeEnd) {
            _fileName = 'VIP平台信息表' + this.formInline.createTimeBegin + '-' + this.formInline.createTimeEnd + '.xls'
          } else {
            _fileName = 'VIP平台信息表' + this.$moment(new Date()).format('YYYY-MM-DD') + '.xls'
          }
          a.download = _fileName
          a.href = event.target.result
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
          loading.close()
        }
      })
    },
    // applyplatform () {
    //   this.$router.push({
    //     path: 'salesmanplatforminfo',
    //     query: { selected: '2' }
    //   })
    // },
    changeDate (val) {
      if (val) {
        this.formInline.createTimeBegin = val[0]
        this.formInline.createTimeEnd = val[1]
      } else {
        this.formInline.createTimeBegin = ''
        this.formInline.createTimeEnd = ''
      }
    },
    sizeChange (pageSize) {
      this.queryInfo.pageSize = pageSize
      this.getPageData()
    },
    pageIndexChange (pageIndex) {
      this.queryInfo.pageNum = pageIndex
      this.getPageData()
    },
    getPageData () {
      this.queryInfo.total = Math.ceil(this.queryInfo.total / this.queryInfo.pageSize)
      this.tableData = this.tableData.slice(this.queryInfo.pageSize * (this.queryInfo.pageNum - 1), this.queryInfo.pageSize * this.queryInfo.pageNum)
    }
  }
}
</script>
<style scoped lang="less">
@import "index";
@deep: ~">>>";

@{deep} .data-list .el-table tr td {
  height: 40px !important;
  padding: 0 !important;
}
</style>
